import { render, staticRenderFns } from "./PreviewLanguageSelection.vue?vue&type=template&id=4f514c1f&scoped=true&"
import script from "./PreviewLanguageSelection.vue?vue&type=script&lang=js&"
export * from "./PreviewLanguageSelection.vue?vue&type=script&lang=js&"
import style0 from "./PreviewLanguageSelection.vue?vue&type=style&index=0&id=4f514c1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f514c1f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
